import Swiper, { Autoplay } from "swiper";

export function blockPartnersSlider() {
  new Swiper(".partenaires-slider__swiper", {
    modules: [ Autoplay],
    direction: "horizontal",
    slidesPerView: 2,
    spaceBetween: 10,
    speed: 5000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    loop: true,
    breakpoints: {
      640: {
        slidesPerView: 4,
      },
      1025: {
        slidesPerView: 6,
      }
    }
  });
}
